import { makeStyles } from "@material-ui/core";

const evaluationStyles = makeStyles(() => ({
  titleRow: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
  },
  filtersPaper: {
    border: "1px solid #dbe6f3",
    borderRadius: 12,
    padding: 14,
    marginBottom: 2,
    backgroundColor: "#ffffff",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
  },
  filtersHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  filtersTitle: {
    fontSize: 13,
    fontWeight: 800,
    color: "#1f2a44",
  },
  filtersSubtitle: {
    marginTop: 2,
    fontSize: 11,
    color: "#64748b",
  },
  resetFiltersButton: {
    minWidth: 120,
    height: 38,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 700,
    borderColor: "#d8e2ef",
    color: "#4b6488",
    backgroundColor: "#ffffff",
  },
  filterToggleButton: {
    minWidth: 165,
    height: 38,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 700,
    borderColor: "#c7d7eb",
    marginLeft: "12px !important",
    color: "#2563eb",
    backgroundColor: "#f8fbff",
  },
  filtersBar: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
    marginTop: 14,
    paddingTop: 14,
    borderTop: "1px solid #eef3fa",
  },
  dateRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    border: "1px solid #eef3fa",
    borderRadius: 8,
    padding: "10px 12px",
    backgroundColor: "#f8fbff",
  },
  dateLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#4b6488",
    minWidth: 140,
  },
  dateInput: {
    minWidth: 170,
  },
  clearDateButton: {
    textTransform: "none",
    borderRadius: 8,
    fontWeight: 600,
    height: 40,
  },
  autocomplete: {
    minWidth: 180,
    width: "100%",
  },
  smallAutocompleteListbox: {
    "& .MuiAutocomplete-option": {
      fontSize: 13,
      minHeight: 30,
    },
  },
  smallAutopComplete: {
    "& .MuiFormLabel-root": {
      fontSize: 13,
    },
    "& .MuiInputBase-input": {
      fontSize: 13,
    },
    "& .MuiChip-label": {
      fontSize: 10,
    },
    "& .MuiAutocomplete-tag": {
      height: 20,
    },
  },
  filterButton: {
    minWidth: 110,
    height: 40,
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 600,
  },
  paper: {
    border: "0.8px solid #dbe6f3",
    borderRadius: 20,
    overflow: "hidden",
    backgroundColor: "#ffffff",
  },
  grid: {
    border: "none",
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#f8fbff",
      borderBottom: "0.8px solid #dbe6f3",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: 10,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.4px",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "0.8px solid #eef3fa",
      fontSize: 12,
      color: "#4b6488",
      fontFamily: "'DM Sans', sans-serif",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#f6faff",
    },
  },
  badge: {
    display: "inline-block",
    padding: "2px 7px",
    borderRadius: 4,
    fontSize: 8,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.4px",
    whiteSpace: "nowrap",
    lineHeight: 1.35,
  },
  badgeSituationEncours: {
    background: "rgba(52,211,153,.15)",
    color: "#16a34a",
  },
  badgeSituationFin: {
    background: "rgba(75,96,128,.2)",
    color: "#64748b",
  },
  badgeSituationResilie: {
    background: "rgba(248,113,113,.15)",
    color: "#dc2626",
  },
  badgeEvalGood: {
    background: "rgba(52,211,153,.15)",
    color: "#16a34a",
  },
  badgeEvalAverage: {
    background: "rgba(251,191,36,.15)",
    color: "#d97706",
  },
  badgeEvalPoor: {
    background: "rgba(248,113,113,.15)",
    color: "#dc2626",
  },
  badgeEvalAcceptable: {
    background: "rgba(79,142,247,.16)",
    color: "#2563eb",
  },
  badgeMissing: {
    background: "rgba(248,113,113,.1)",
    color: "#dc2626",
    border: "1px dashed #dc2626",
  },
  monoCell: {
    fontFamily: "'DM Mono', monospace",
    color: "#4b6488",
  },
  ficheButton: {
    border: "1px solid rgba(79,142,247,.35)",
    borderRadius: 6,
    color: "#2563eb",
    padding: 4,
    "&:hover": {
      backgroundColor: "rgba(79,142,247,.12)",
    },
  },
  "@media (max-width: 720px)": {
    filtersPaper: {
      padding: 12,
      borderRadius: 10,
    },
    filtersHeader: {
      alignItems: "flex-start",
    },
    filterToggleButton: {
      flex: 1,
      minWidth: 0,
    },
    resetFiltersButton: {
      flex: 1,
      minWidth: 0,
    },
    dateRow: {
      alignItems: "stretch",
    },
    dateLabel: {
      width: "100%",
      minWidth: 0,
    },
    dateInput: {
      width: "100%",
      minWidth: 0,
    },
  },
}));

export default evaluationStyles;
